import type { OptionProps } from 'react-select';

type OptionLayoutLanguageTrackerOption = {
  label: string;
  value?: string;
};

type OptionLayoutLanguageTrackerProps = OptionProps<
  OptionLayoutLanguageTrackerOption,
  false
>;

const OptionLayoutLanguageTracker = (
  props: OptionLayoutLanguageTrackerProps
) => {
  const { innerProps, innerRef } = props;
  return (
    <>
      <style>{`
          .customized-searchbox-option:hover{
            background-color:var(--falcon-gray-link-hover-300) !important;
          }
          .customized-searchbox-option{
            background-color:var(--falcon-tertiary-bg) !important;
          }
    
          `}</style>
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          backgroundColor: props.isSelected
            ? 'var(--falcon-gray-link-hover-100)'
            : 'var(--falcon-dropdown-bg-global)'
        }}
        className="p-2 cursor-pointer border border-1  customized-searchbox-option"
      >
        <div className="fs--1 text-900 d-flex align-items-center gap-2">
          {/* {props.data?.label && (
            <img
              src={`https://static.mizfa.tools/flags/${props.data.label}.webp`}
              alt="country icon"
              width="20px"
              loading="lazy"
              height="11px"
            />
          )} */}
          {props.data.label}{' '}
        </div>
      </div>
    </>
  );
};

export default OptionLayoutLanguageTracker;
